@if (success && mode === 'CONFIRM') {
<h1 mat-dialog-title>{{ 'scheduler.booking.confirm.success.title' | translate }}</h1>
}
@if (success && mode === 'CANCEL') {
<h1 mat-dialog-title>{{ 'scheduler.booking.cancel.success.title' | translate }}</h1>
}
@if (success && mode === 'REFER') {
<h1 mat-dialog-title>{{ 'scheduler.booking.refer.success.title' | translate }}</h1>
}
@if (!success) {
<h1 mat-dialog-title>{{ 'scheduler.booking.confirm.failure.title' | translate }}</h1>
}


@if (success) {
<mat-dialog-content>
  <p>
    <strong>
      {{ message }}
    </strong>
  </p>
  @if (mode==='CONFIRM') {
  <p>
    {{ 'scheduler.booking.confirm.success.message' | translate }}
  </p>
  }
  @if (mode==='CANCEL') {
  <p>
    {{ 'scheduler.booking.cancel.success.message' | translate }}
  </p>
  }
  @if (mode==='REFER') {
  <p>
    {{ 'scheduler.booking.refer.success.message' | translate }}
  </p>
  }
</mat-dialog-content>
}
@if (!success) {
<mat-dialog-content>
  <p>
    <strong>
      {{ message }}
    </strong>
  </p>
  <p>
    {{ 'scheduler.booking.confirm.failure.message' | translate }}
  </p>
</mat-dialog-content>
}

@if (success) {
<mat-dialog-actions align="end">
  <button color="warn" mat-button mat-dialog-close>{{ 'scheduler.general.ok' | translate }}</button>
</mat-dialog-actions>
}

@if (!success) {
<mat-dialog-actions align="end">
  <button color="warn" mat-button mat-dialog-close>{{ 'scheduler.general.abandon' | translate }}</button>
  <button (click)="onRetryClick()" cdkFocusInitial color="primary" mat-raised-button>{{ 'scheduler.booking.retry.title'
    | translate }}
  </button>
</mat-dialog-actions>
}